import { DetailsBooking } from 'types';
import getDescription from './utils/getDescription';

const getCalendarFields = (booking: DetailsBooking) => {
  return {
    location: booking.reservation.property.formattedAddressFull,
    startDate: new Date(booking.reservation.checkInDateTime),
    endDate: new Date(booking.reservation.checkOutDateTime),
    title: booking.summaryText,
    url: booking.links.manage,
    description: getDescription(booking),
  };
};

export default getCalendarFields;
